import classNames from 'classnames';
import { useCallback } from 'react';
import gem from '~/components/Icon/gem.animated.png';
import styles from './ChallengeScoreUpEffect.module.scss';

export type ChallengeScoreUpEffectProps = {
  className?: string;
};

export const ChallengeScoreUpEffect = ({ className }: ChallengeScoreUpEffectProps) => {
  const ref = useCallback((el: HTMLElement | null) => {
    if (!el) return;

    const rect = el.getBoundingClientRect();

    const cx = window.innerWidth / 2 - rect.x - rect.width / 2;
    const cy = window.innerHeight / 2 - rect.y - rect.height / 2;

    el.style.setProperty('--cx', `${cx}px`);
    el.style.setProperty('--cy', `${cy}px`);
  }, []);

  const imageRef = useCallback((element: HTMLImageElement) => {
    if (element) element.src = gem;
  }, []);

  return (
    <div className={classNames(styles.root, className)} ref={ref}>
      {Array.from({ length: 11 }).map((_, i) => (
        <div className={classNames(styles.item, styles[`object${i + 1}`])} key={i}>
          <div className={styles.inner}>
            <img className={styles.image} ref={imageRef} width={30} height={30} alt="flame" />
          </div>
        </div>
      ))}
    </div>
  );
};
